<template>
  <!-- start slider -->
  <div
    v-if="getSliderItems.length > 0"
    class="bg-third border-radius-xl p-24 px-xl-16 mx-xl-n16 mt-60 mt-md-40"
  >
    <div class="fs-28 fw-medium fs-md-20">
      Рекомендуем вместе с выбранным товаром комплексные решения
    </div>
    <div
      class="slider slider_arrows-middle relative mt-24 mx-n24 px-24 mx-xl-n16 px-xl-16"
    >
      <div
        class="slider__arrow slider__arrow_next border-radius-md bg-white icon-48 text-dark hover-primary d-flex d-xl-none js-recommendations-slider-next"
      >
        <div class="icon-20">
          <svg>
            <use
              xlink:href="/local/front2/styles/icons/sprite.svg#icon-chevron-right"
            />
          </svg>
        </div>
      </div>
      <div
        class="slider__arrow slider__arrow_prev border-radius-md bg-white icon-48 text-dark hover-primary d-flex d-xl-none js-recommendations-slider-prev"
      >
        <div class="icon-20">
          <svg>
            <use
              xlink:href="/local/front2/styles/icons/sprite.svg#icon-chevron-left"
            />
          </svg>
        </div>
      </div>

      <div class="overflow-hidden border-radius-lg mx-xl-n16 px-xl-16">
        <div
          class="slider-products overflow-visible swiper js-recommendations-slider"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(product, index) in getSliderItems"
              :key="`product-${index}`"
              class="slider-products__slide swiper-slide"
            >
              <!-- product -->
              <div
                class="product border-stroke-outermost h-100 bg-white px-16 pb-16 border-radius-lg d-flex d-flex_column"
                :class="{ 'pt-8': hasRecommendationDescription }"
              >
                <div
                  v-if="hasRecommendationDescription"
                  class="product__title pt-8 px-16 pb-16 text-center mb-16 border-radius-md"
                >
                  <div class="icon-24 mx-auto color-tertiary">
                    <svg>
                      <use
                        xlink:href="/local/front2/styles/icons/sprite.svg?t=1751023612#icon-heart-plus"
                      />
                    </svg>
                  </div>
                  <div
                    v-if="product.recommendation_description?.trim()"
                    class="mt-8 fw-medium fs-14"
                  >
                    {{ product.recommendation_description }}
                  </div>
                </div>

                <div class="slider relative pb-20">
                  <a
                    :href="'/product/' + product.fields.code + '/'"
                    class="d-block"
                  >
                    <div
                      v-if="product.media && product.media.length > 1"
                      :class="`slider-inside swiper border-radius-md js-product-inside-slider js-product-inside-slider-${index}`"
                    >
                      <div class="swiper-wrapper">
                        <div
                          v-for="(image, imgIndex) in product.media.filter(
                            (img) => img.type === 'main' || img.type === 'image'
                          )"
                          :key="`image-${index}-${imgIndex}`"
                          class="swiper-slide"
                        >
                          <img
                            width="244"
                            height="244"
                            class="img-cover"
                            :alt="product.fields.name || 'alt'"
                            :title="product.fields.name || 'title'"
                            :src="image.sizes?.default || null"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-else class="border-radius-md">
                      <img
                        width="244"
                        height="244"
                        class="img-cover"
                        :alt="product.alt || 'alt'"
                        :title="product.title || 'title'"
                        :src="
                          product.media && product.media.length > 0
                            ? product.media[0].sizes?.default
                            : null
                        "
                      />
                    </div>
                  </a>

                  <div
                    v-if="product.media && product.media.length > 1"
                    :class="`slider__pagination absolute js-product-inside-slider-pagination js-product-inside-slider-pagination-${index}`"
                  />

                  <div
                    class="product__action absolute d-flex d-flex_middle d-flex_reverse d-flex_between pr-4"
                  >
                    <button
                      class="product__favorite btn color-gray hover-primary icon-16 js-product-favorite"
                      :class="{ 'is-active': product.isFavorite }"
                      @click="this.addWishList(product.fields.id)"
                    >
                      <svg>
                        <use
                          xlink:href="/local/front2/styles/icons/sprite.svg#icon-heart"
                        />
                      </svg>
                    </button>

                    <div
                      v-if="product.properties?.size_discount?.value > 0"
                      :class="`label fs-14 border-radius-rounded label_primary`"
                    >
                      -{{ product.properties?.size_discount?.value }}%
                    </div>
                  </div>
                </div>

                <div class="grid-col_full pt-8">
                  <div class="d-flex d-flex_middle">
                    <div class="nowrap fs-20 fw-semibold">
                      {{
                        new Intl.NumberFormat("ru-RU").format(
                          product.properties?.min_discount_price?.value
                        )
                      }}
                      ₽
                    </div>
                    <div
                      v-if="product.properties?.size_discount?.value > 0"
                      class="nowrap color-gray price-old ml-12"
                    >
                      {{
                        new Intl.NumberFormat("ru-RU").format(
                          product.properties?.min_price?.value
                        )
                      }}
                      ₽
                    </div>
                  </div>

                  <a
                    :href="'/product/' + product.fields.code + '/'"
                    class="product__name mt-4"
                  >
                    {{ product.fields.name }}
                  </a>
                </div>
              </div>
              <!-- /product -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end slider -->
</template>

<script>
import { useRecommendedStore } from "@/pages/product_card/stores/store_recommended";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
import { onMounted, onBeforeUnmount, nextTick } from "vue";

export default {
  name: "SliderProducts",
  setup() {
    let swiperRecommendation = null;
    const insideSliders = {};
    let isMobile = false;

    const initMainSlider = () => {
      // Уничтожаем предыдущий слайдер если он существует
      if (swiperRecommendation) {
        swiperRecommendation.destroy(true, true);
        swiperRecommendation = null;
      }

      // Инициализация основного слайдера
      const mainSliderElement = document.querySelector(
        ".js-recommendations-slider"
      );
      if (mainSliderElement && window.Swiper) {
        swiperRecommendation = new window.Swiper(".js-recommendations-slider", {
          spaceBetween: 8,
          slidesPerView: "auto",
          watchOverflow: true,
          navigation: {
            nextEl: ".js-recommendations-slider-next",
            prevEl: ".js-recommendations-slider-prev",
          },
          breakpoints: {
            768: {
              spaceBetween: 16,
            },
          },
        });
      }
    };

    const initInsideSliders = () => {
      if (!window.Swiper) return;

      isMobile = window.innerWidth < 768;

      // Уничтожаем существующие слайдеры
      Object.keys(insideSliders).forEach((key) => {
        if (insideSliders[key]) {
          const sliderElement = document.querySelector(
            `.js-product-inside-slider-${key}`
          );
          if (sliderElement) {
            sliderElement.removeEventListener(
              "mousemove",
              insideSliders[key].onMouseMove
            );
            sliderElement.removeEventListener(
              "mouseleave",
              insideSliders[key].onMouseLeave
            );
          }
          insideSliders[key].swiper.destroy(true, true);
          delete insideSliders[key];
        }
      });

      // Инициализируем новые слайдеры
      const insideSliderElements = document.querySelectorAll(
        ".js-product-inside-slider"
      );
      insideSliderElements.forEach((sliderElement, index) => {
        const swiper = new window.Swiper(sliderElement, {
          loop: false,
          autoplay: false,
          speed: 500,
          pagination: {
            el: `.js-product-inside-slider-pagination-${index}`,
          },
          effect: isMobile ? "slide" : "fade",
        });

        const onMouseMove = (event) => {
          if (isMobile || !swiper || !swiper.slides) return;

          const sliderRect = sliderElement.getBoundingClientRect();
          const mouseX = event.clientX - sliderRect.left;
          const realSlidesCount =
            swiper && swiper.slides ? swiper.slides.length : 0;
          const step = sliderRect.width / realSlidesCount;

          let targetIndex = Math.floor(mouseX / step);

          if (targetIndex < 0) targetIndex = 0;
          if (targetIndex >= realSlidesCount) targetIndex = realSlidesCount - 1;

          if (targetIndex !== swiper.realIndex) {
            swiper.slideTo(targetIndex, 500);
          }
        };

        const onMouseLeave = () => {
          if (isMobile || !swiper || !swiper.slides) return;

          swiper.slideTo(0, 500);
        };

        if (!isMobile) {
          sliderElement.addEventListener("mousemove", onMouseMove);
          sliderElement.addEventListener("mouseleave", onMouseLeave);
        }

        insideSliders[index] = {
          swiper,
          onMouseMove,
          onMouseLeave,
        };
      });
    };

    const initFavoriteButtons = () => {
      const favoriteButtons = document.querySelectorAll(".js-product-favorite");
      favoriteButtons.forEach((favButton) => {
        // Удаляем предыдущие обработчики
        favButton.removeEventListener("click", favButton.clickHandler);

        // Добавляем новый обработчик
        favButton.clickHandler = () => {
          favButton.classList.toggle("is-active");
        };
        favButton.addEventListener("click", favButton.clickHandler);
      });
    };

    const handleResize = () => {
      initInsideSliders();
    };

    const initSliders = () => {
      // Ждем следующий тик для обеспечения рендеринга DOM
      nextTick(() => {
        setTimeout(() => {
          initMainSlider();
          initInsideSliders();
          initFavoriteButtons();
        }, 100);
      });
    };

    onMounted(() => {
      // Проверяем наличие Swiper в глобальной области
      if (window.Swiper) {
        initSliders();
      } else {
        // Если Swiper еще не загружен, ждем его загрузки
        const checkSwiper = setInterval(() => {
          if (window.Swiper) {
            clearInterval(checkSwiper);
            initSliders();
          }
        }, 100);

        // Очищаем интервал через 5 секунд, если Swiper не загрузился
        setTimeout(() => {
          clearInterval(checkSwiper);
        }, 5000);
      }

      window.addEventListener("resize", handleResize);
      window.addEventListener("load", initSliders);
    });

    onBeforeUnmount(() => {
      // Очистка ресурсов
      if (swiperRecommendation) {
        swiperRecommendation.destroy(true, true);
      }

      Object.keys(insideSliders).forEach((key) => {
        if (insideSliders[key]) {
          const sliderElement = document.querySelector(
            `.js-product-inside-slider-${key}`
          );
          if (sliderElement) {
            sliderElement.removeEventListener(
              "mousemove",
              insideSliders[key].onMouseMove
            );
            sliderElement.removeEventListener(
              "mouseleave",
              insideSliders[key].onMouseLeave
            );
          }
          insideSliders[key].swiper.destroy(true, true);
        }
      });

      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", initSliders);
    });

    return {};
  },
  computed: {
    ...mapState(useRecommendedStore, ["getSliderItems"]),
    ...mapState(useProductStore, ["addWishList"]),
    hasRecommendationDescription() {
      return (
        this.getSliderItems?.some((product) =>
          product.recommendation_description?.trim()
        ) || false
      );
    },
  },
  watch: {
    getSliderItems: {
      handler() {
        if (this.getSliderItems && this.getSliderItems.length > 0) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.initMainSlider();
              this.initInsideSliders();
              this.initFavoriteButtons();
            }, 100);
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    initMainSlider() {
      // Перенесены в setup
    },
    initInsideSliders() {
      // Перенесены в setup
    },
    initFavoriteButtons() {
      // Перенесены в setup
    },
  },
};
</script>

<style scoped>
#product-recommended .bg-third {
  margin-left: -1px;
  margin-right: -1px;
}
.slider-products .slider-products__slide {
  height: auto;
  width: 276px;
}
.swiper.slider-products {
  overflow: visible;
}
@media (max-width: 576px) {
  .slider-products .slider-products__slide {
    width: 217px;
  }
}
</style>
